import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import { TutorialService } from "../../../../auth/service/tutorial.service";
import { Itutorial } from "../../../../auth/models/tutorial-interface";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-tutorial-list-for-user",
  templateUrl: "./tutorial-list-for-user.component.html",
  styleUrls: ["./tutorial-list-for-user.component.scss"],
})
export class TutorialListForUserComponent implements OnInit {
  public contentHeader: IContentHeader;

  public tutorial_list: Itutorial[] = null;

  public searchKey: string = "";

  public filteredTutorials: Itutorial[] = [];

  constructor(public _tutorialService: TutorialService) {
    this.contentHeader = {
      headerTitle: italian.data.MENU.TUTORIAL,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.TUTORIAL,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.tutorial_list = await this._tutorialService.getList();
    this.tutorial_list = this.tutorial_list.sort((a, b) => (a.title > b.title ? 1 : -1));
    await this.searchTutorial();
  }

  async searchTutorial() {
    const key: string = this.searchKey.trim().toLowerCase();
    let items = this.tutorial_list;
    if (key.length > 1) {
      items = items.filter((item) => item.title.toLowerCase().includes(key));
    }
    this.filteredTutorials = items;
  }

  showVideo(tutorial: Itutorial) {
    this._tutorialService.video_to_play = tutorial.title;
    this._tutorialService.force_open_modal = true;
  }
}
